import type { OutcomeCondition } from "@repo/app-types/entities/filterConditions";
import type { OutcomeDefinition } from "@repo/app-types/entities/outcome";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { Size } from "@repo/ui/helpers/helpers";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import type { FC } from "react";
import { OutcomeResultPill } from "../teammatePerformance/outcomeValuePill.js";

export interface OutcomeConditionsMenuProps {
  playbookId: PlaybookId;
  outcomeDefinition: OutcomeDefinition;
  onSelect: (condition: OutcomeCondition) => void;
}

export const OutcomeConditionsMenu: FC<OutcomeConditionsMenuProps> = ({
  playbookId,
  outcomeDefinition,
  onSelect,
}) => {
  return (
    <SimpleMenu aria-label="Filter by outcome">
      {outcomeDefinition.results.map((result) => (
        <SimpleMenuItem
          key={result.value}
          onAction={() =>
            onSelect({
              playbookId,
              outcomeType: outcomeDefinition.type,
              outcomeDefinitionId: outcomeDefinition.id,
              outcomeValue: result.value,
              outcomeLabel: result.label,
              operator: "=",
              value: result.value,
            })
          }
        >
          <span className="flex items-center gap-2">
            Outcome is <OutcomeResultPill size={Size.SMALL} result={result} />
          </span>
        </SimpleMenuItem>
      ))}
    </SimpleMenu>
  );
};
